export const coldEmailGettingStartedArticle = {
  title: 'Cold Email Engine: Getting Started',
  slug: 'cold-email-getting-started',
  content: `Cold Email Engine: Getting Started

Use the Cold Email Engine to build campaigns, manage mailboxes, and track engagement.

1) Open the workspace
- Go to /email.
- The sidebar groups features into Main, Manage, and Insights.

2) Connect mailboxes
- Open Mailboxes to add SMTP/IMAP credentials.
- Test the connection before saving.

3) Load contacts
- Use Contacts to import or create recipients.

4) Create campaigns
- Use Campaigns to build sequences and schedule sends.
- Templates and AI helpers are available from the campaigns flow.

5) Monitor results
- Analytics and Lead Intelligence show engagement and scoring.
`,
};
